"use client";
/**
 * Serviço para gerenciamento de usuários
 */

import {
  createUserApi,
  findAllUsersApi,
  findOneUserApi,
  updateUserApi,
  deleteUserApi,
  getCurrentUserApi,
  findAllAdminUsersApi,
  getAccessHistoryApi,
} from "@/domains/users/user.api";
import {
  UserCreateType,
  UserResponseType,
  UsersResponseType,
  UserUpdateType,
  AccessHistoryResponseType
} from "@/domains/users/user.type";

/**
 * Cria um novo usuário
 * @param data Dados do usuário
 * @returns Resposta da API com o usuário criado
 */
export async function createUserService(data: UserCreateType): Promise<UserResponseType> {
  return await createUserApi(data);
}

/**
 * Busca todos os usuários
 * @returns Resposta da API com a lista de usuários
 */
export async function findAllUsersService(): Promise<UsersResponseType> {
  return await findAllUsersApi();
}

/**
 * Busca um usuário pelo UUID
 * @param uuid UUID do usuário
 * @returns Resposta da API com o usuário
 */
export async function findOneUserService(uuid: string): Promise<UserResponseType> {
  return await findOneUserApi(uuid);
}

/**
 * Atualiza um usuário
 * @param uuid UUID do usuário
 * @param data Dados do usuário
 * @returns Resposta da API com o usuário atualizado
 */
export async function updateUserService(uuid: string, data: UserUpdateType): Promise<UserResponseType> {
  return await updateUserApi(uuid, data);
}

/**
 * Exclui um usuário
 * @param uuid UUID do usuário
 * @returns Resposta da API
 */
export async function deleteUserService(uuid: string): Promise<UserResponseType> {
  return await deleteUserApi(uuid);
}

/**
 * Busca os dados do usuário autenticado
 * @returns Resposta da API com os dados do usuário autenticado
 */
export async function getCurrentUserService(): Promise<UserResponseType> {
  return await getCurrentUserApi();
}

/**
 * Busca todos os usuários para administração
 * @returns Resposta da API com a lista de usuários para administração
 */
export async function findAllAdminUsersService(): Promise<UsersResponseType> {
  return await findAllAdminUsersApi();
}

/**
 * Busca o histórico de acesso do usuário autenticado
 * @returns Resposta da API com o histórico de acesso
 */
export async function getAccessHistoryService(): Promise<AccessHistoryResponseType> {
  return await getAccessHistoryApi();
}

